import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
class GetProfitAndLossResponseSectionRowColumnData {
  static fromProto(proto) {
    let m = new GetProfitAndLossResponseSectionRowColumnData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class Company {
  static fromProto(proto) {
    let m = new Company();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class ConnectionInfo {
  static fromProto(proto) {
    let m = new ConnectionInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn['logoUrl'] = this.logoUrl;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    return toReturn;
  }
}
class GetAgingSummaryRequest {
  static fromProto(proto) {
    let m = new GetAgingSummaryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetAgingSummaryResponse {
  static fromProto(proto) {
    let m = new GetAgingSummaryResponse();
    m = Object.assign(m, proto);
    if (proto.row) {
      m.row = proto.row.map(GetAgingSummaryResponseRow.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.row !== 'undefined' && this.row !== null) {
      toReturn['row'] = 'toApiJson' in this.row ? this.row.toApiJson() : this.row;
    }
    return toReturn;
  }
}
class GetAuthorizationCodeRedirectURLRequest {
  static fromProto(proto) {
    let m = new GetAuthorizationCodeRedirectURLRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetAuthorizationCodeRedirectURLResponse {
  static fromProto(proto) {
    let m = new GetAuthorizationCodeRedirectURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class GetConnectedCompanyRequest {
  static fromProto(proto) {
    let m = new GetConnectedCompanyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetConnectedCompanyResponse {
  static fromProto(proto) {
    let m = new GetConnectedCompanyResponse();
    m = Object.assign(m, proto);
    if (proto.company) {
      m.company = Company.fromProto(proto.company);
    }
    if (proto.connectionInfo) {
      m.connectionInfo = ConnectionInfo.fromProto(proto.connectionInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.company !== 'undefined' && this.company !== null) {
      toReturn['company'] = 'toApiJson' in this.company ? this.company.toApiJson() : this.company;
    }
    if (typeof this.connectionInfo !== 'undefined' && this.connectionInfo !== null) {
      toReturn['connectionInfo'] = 'toApiJson' in this.connectionInfo ? this.connectionInfo.toApiJson() : this.connectionInfo;
    }
    return toReturn;
  }
}
class GetProfitAndLossRequest {
  static fromProto(proto) {
    let m = new GetProfitAndLossRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class GetProfitAndLossResponse {
  static fromProto(proto) {
    let m = new GetProfitAndLossResponse();
    m = Object.assign(m, proto);
    if (proto.income) {
      m.income = GetProfitAndLossResponseSection.fromProto(proto.income);
    }
    if (proto.expenses) {
      m.expenses = GetProfitAndLossResponseSection.fromProto(proto.expenses);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.income !== 'undefined' && this.income !== null) {
      toReturn['income'] = 'toApiJson' in this.income ? this.income.toApiJson() : this.income;
    }
    if (typeof this.expenses !== 'undefined' && this.expenses !== null) {
      toReturn['expenses'] = 'toApiJson' in this.expenses ? this.expenses.toApiJson() : this.expenses;
    }
    return toReturn;
  }
}
class RevokeAccessTokenRequest {
  static fromProto(proto) {
    let m = new RevokeAccessTokenRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetProfitAndLossResponseSectionRow {
  static fromProto(proto) {
    let m = new GetProfitAndLossResponseSectionRow();
    m = Object.assign(m, proto);
    if (proto.column) {
      m.column = GetProfitAndLossResponseSectionRowColumnData.fromProto(proto.column);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.column !== 'undefined' && this.column !== null) {
      toReturn['column'] = 'toApiJson' in this.column ? this.column.toApiJson() : this.column;
    }
    return toReturn;
  }
}
class GetAgingSummaryResponseRow {
  static fromProto(proto) {
    let m = new GetAgingSummaryResponseRow();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.columnValue !== 'undefined') {
      toReturn['columnValue'] = this.columnValue;
    }
    return toReturn;
  }
}
class GetProfitAndLossResponseSection {
  static fromProto(proto) {
    let m = new GetProfitAndLossResponseSection();
    m = Object.assign(m, proto);
    if (proto.rows) {
      m.rows = proto.rows.map(GetProfitAndLossResponseSectionRow.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rows !== 'undefined' && this.rows !== null) {
      toReturn['rows'] = 'toApiJson' in this.rows ? this.rows.toApiJson() : this.rows;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'quickbooks-api.vendasta-local.com',
  'test': '',
  'demo': 'quickbooks-demo.apigateway.co',
  'prod': 'quickbooks-prod.apigateway.co',
  'production': 'quickbooks-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let QuickBooksApiService = /*#__PURE__*/(() => {
  class QuickBooksApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAuthorizationCodeRedirectUrl(r) {
      const request = r.toApiJson ? r : new GetAuthorizationCodeRedirectURLRequest(r);
      return this.http.post(this._host + "/quickbooks.v1.QuickBooks/GetAuthorizationCodeRedirectURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAuthorizationCodeRedirectURLResponse.fromProto(resp)));
    }
    revokeAccessToken(r) {
      const request = r.toApiJson ? r : new RevokeAccessTokenRequest(r);
      return this.http.post(this._host + "/quickbooks.v1.QuickBooks/RevokeAccessToken", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getConnectedCompany(r) {
      const request = r.toApiJson ? r : new GetConnectedCompanyRequest(r);
      return this.http.post(this._host + "/quickbooks.v1.QuickBooks/GetConnectedCompany", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConnectedCompanyResponse.fromProto(resp)));
    }
    getAccountsReceivableAgingSummary(r) {
      const request = r.toApiJson ? r : new GetAgingSummaryRequest(r);
      return this.http.post(this._host + "/quickbooks.v1.QuickBooks/GetAccountsReceivableAgingSummary", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAgingSummaryResponse.fromProto(resp)));
    }
    getAccountsPayableAgingSummary(r) {
      const request = r.toApiJson ? r : new GetAgingSummaryRequest(r);
      return this.http.post(this._host + "/quickbooks.v1.QuickBooks/GetAccountsPayableAgingSummary", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAgingSummaryResponse.fromProto(resp)));
    }
    getProfitAndLoss(r) {
      const request = r.toApiJson ? r : new GetProfitAndLossRequest(r);
      return this.http.post(this._host + "/quickbooks.v1.QuickBooks/GetProfitAndLoss", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetProfitAndLossResponse.fromProto(resp)));
    }
  }
  QuickBooksApiService.ɵfac = function QuickBooksApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || QuickBooksApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  QuickBooksApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: QuickBooksApiService,
    factory: QuickBooksApiService.ɵfac,
    providedIn: 'root'
  });
  return QuickBooksApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let QuickBooksService = /*#__PURE__*/(() => {
  class QuickBooksService {
    constructor(quickBooksApiService) {
      this.quickBooksApiService = quickBooksApiService;
    }
    getAccountsReceivableAgingSummary(businessId, userId) {
      return this.quickBooksApiService.getAccountsReceivableAgingSummary(new GetAgingSummaryRequest({
        businessId: businessId,
        userId: userId
      }));
    }
    getAccountsPayableAgingSummary(businessId, userId) {
      return this.quickBooksApiService.getAccountsPayableAgingSummary(new GetAgingSummaryRequest({
        businessId: businessId,
        userId: userId
      }));
    }
    getProfitAndLoss(businessId, userId, startDate, endDate) {
      return this.quickBooksApiService.getProfitAndLoss(new GetProfitAndLossRequest({
        businessId: businessId,
        userId: userId,
        startDate: startDate,
        endDate: endDate
      }));
    }
    getConnectedCompany(businessId, userId) {
      return this.quickBooksApiService.getConnectedCompany(new GetConnectedCompanyRequest({
        businessId: businessId,
        userId: userId
      })).pipe(map(resp => {
        return resp.company;
      }));
    }
    getAuthorizationCodeRedirectUrl(businessId, userId) {
      return this.quickBooksApiService.getAuthorizationCodeRedirectUrl(new GetAuthorizationCodeRedirectURLRequest({
        businessId: businessId,
        userId: userId
      })).pipe(map(resp => {
        return resp.url;
      }));
    }
    revokeAccessToken(businessId, userId) {
      return this.quickBooksApiService.revokeAccessToken(new RevokeAccessTokenRequest({
        businessId: businessId,
        userId: userId
      })).pipe(map(() => true));
    }
  }
  QuickBooksService.ɵfac = function QuickBooksService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || QuickBooksService)(i0.ɵɵinject(QuickBooksApiService));
  };
  QuickBooksService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: QuickBooksService,
    factory: QuickBooksService.ɵfac,
    providedIn: 'root'
  });
  return QuickBooksService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Company, ConnectionInfo, GetAgingSummaryRequest, GetAgingSummaryResponse, GetAgingSummaryResponseRow, GetAuthorizationCodeRedirectURLRequest, GetAuthorizationCodeRedirectURLResponse, GetConnectedCompanyRequest, GetConnectedCompanyResponse, GetProfitAndLossRequest, GetProfitAndLossResponse, GetProfitAndLossResponseSection, GetProfitAndLossResponseSectionRow, GetProfitAndLossResponseSectionRowColumnData, QuickBooksApiService, QuickBooksService, RevokeAccessTokenRequest };
